/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon16Regular = forwardRef('DocIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 1A2.75 2.75 0 0 0 2 3.75v8.5A2.75 2.75 0 0 0 4.75 15h5.5A2.75 2.75 0 0 0 13 12.25V5.653c0-.464-.184-.909-.512-1.237L9.584 1.513A1.75 1.75 0 0 0 8.347 1H4.75ZM3.5 3.75c0-.69.56-1.25 1.25-1.25h2.5v3c0 .69.56 1.25 1.25 1.25h3v5.5c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25v-8.5Zm7.7 1.5L8.75 2.8v2.45h2.45Z" })));
});
